// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import {
  ChannelBox,
  ChannelBoxTypes,
  GeoMap
} from "src/controllers/alerts/components";
import { Classes, MPDButton } from "src/mpd-library";

import "./styles.css";

export interface IMainProps extends HTMLDivProps {
  groupTagList?: Array<any>;
  everyoneStatus: boolean;
  groupsStatus: boolean;
  geoFence: any;
  onClearMap?(event: any): void;
  onGeoFenceClick?(event: any): void;
  onBoxClick?(event: any): void;
}

export const Main: React.SFC<IMainProps> = props => {
  const {
    className,
    everyoneStatus,
    groupsStatus,
    groupTagList,
    onClearMap,
    geoFence,
    onBoxClick
  } = props;
  const classes = classNames(className);

  return (
    <div className={classes}>
      <div className="types-container">
        <Text className="alerts-content-compose-subtitle">Choose audience</Text>
        <ChannelBox
          className={classNames(everyoneStatus && Classes.ACTIVE)}
          id={"everyone"}
          onClick={onBoxClick}
          title="Everyone"
          type={ChannelBoxTypes.default}
          description="Send to everyone inside your jurisdictional boundaries"
          name="compose-alert--audience--everyone"
        />
        <ChannelBox
          className={classNames(groupsStatus && Classes.ACTIVE)}
          id={"group"}  
          onClick={onBoxClick}
          horizontalList={groupTagList}
          title="Group"
          type={ChannelBoxTypes.groups}
          description="Send to a group of users, regardless of location"
          name="compose-alert--audience--groups"
        />
        <Text className="alerts-content-compose-subtitle">
          SET GEO-FENCE <span> (OPTIONAL) </span>
        </Text>
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_MAP_CONTAINER}>
          {geoFence.status ? (
            <div className="wrapper">
              <div
                className="geo-fence-map-container"
                data-id={"geofence"}
                onDoubleClick={onBoxClick}
              >
                <GeoMap
                  style={{
                    height: `100%`,
                    borderRadius: "20px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)"
                  }}
                  hideControls={true}
                  center={geoFence.currentShape.center}
                  currentShape={geoFence.currentShape}
                />
              </div>
              <MPDButton name="compose-alert-exit" onClick={onClearMap} />
            </div>
          ) : (
            <ChannelBox
              id={"geofence"}
              onClick={onBoxClick}
              title="Create Geo-Fence"
              type={ChannelBoxTypes.maps}
              description="Send to a subset of users inside a geo-fenced location"
              name="compose-alert--audience--geofence"
            />
          )}
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/choose-audience/main.tsx